var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"p-coupon-list"},_vm._l((_vm.list.slice(0, 3)),function(item,i){return _c('li',{key:i,on:{"click":function($event){return _vm.couponClicked(item)}}},[_c('coupon-item',{attrs:{"name":_vm.couponText(item)}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }